import styles from '~/templates/blocks/components/M190BrandOverviewStories/components/M190Story/m190story.module.css';

export const M190StorySkeleton = () => {
	return (
		<div className={styles.root}>
			<div className={styles.link}>
				<div className={styles.imageContainer}>
					<div className={styles.storyImage}></div>
				</div>
			</div>
		</div>
	);
};
